import {UmpireImage} from '../umpire-image';
import {UmpireQuizRanking} from '../umpire-quiz-ranking';

export interface UmpireQuizPrize {
  id: string | null;

  type: 'quiz_prize';

  amount: string | null;

  content: string | null;

  currency: 'PLN';

  kind: 'cash' | 'material' | null;

  place_from: number | null;

  place_to: number | null;

  image: UmpireImage | null;

  quiz_ranking: Partial<UmpireQuizRanking> | null;
}
